import { useAuth0 } from "@auth0/auth0-react";

import { Segment } from "../services/segment";
import {
    DOCUSIGN_AUTH_STATE,
    GOOGLE_AUTH_STATE,
    IS_DEV_MODE,
    IS_ONBOARDING_CHECKLIST_HIDDEN,
    SELECTED_CUSTOMER_ID,
    SLACK_AUTH_STATE,
} from "../utils/sessionStorage";

const SEGMENT_WRITE_KEY = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY;

export const useLogout = () => {
    const { logout } = useAuth0();

    return () => {
        sessionStorage.removeItem(SELECTED_CUSTOMER_ID);

        localStorage.removeItem(DOCUSIGN_AUTH_STATE);
        localStorage.removeItem(GOOGLE_AUTH_STATE);
        localStorage.removeItem(SLACK_AUTH_STATE);
        localStorage.removeItem(IS_ONBOARDING_CHECKLIST_HIDDEN);
        localStorage.removeItem(IS_DEV_MODE);

        if (SEGMENT_WRITE_KEY) {
            Segment.reset();
        }

        // We use the same auth0 app for dev and staging, so we need to provide a return url when logging out.
        // https://auth0.com/docs/authenticate/login/logout/redirect-users-after-logout
        // https://github.com/auth0/auth0-react#getting-started
        return logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };
};
